import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const CreateNISParticipantWrapper = styled.div`
  color: ${COLORS.cirrus_black};

  .MuiAccordionSummary-root:not(.activity-timeline .MuiAccordionSummary-root) {
    padding: 0px;
    margin: 0px;
    padding-right: 28px;
  }

  .separator-space {
    margin: 24px 0px;

    ${responsive.MOBILE`
       margin: 16px 8px;
      `}
  }
`;
